import React from 'react';
import { BrowserRouter, Route, Routes as RoutesContainer } from 'react-router-dom';
import { MainLayout, EmptyLayout } from 'layout/index';
import { VehicleDocumentsPage, AttachDocumentsPage } from 'pages/vehicle-documents';
import { SignInPage, SignUpPage } from 'pages/user';
import { RoutesSettings } from 'config/routes';
import { SaveRouteParams, AuthRoute, PrivateRoute } from 'common/route';
import { LAST_REQUEST_ID, AUTH_TOKEN } from 'config/constant';
import ScrollToTop from 'common/layout/scroll-to-top/scroll-to-top';
import { VehiclesPage } from 'pages/vehicles';

export const Routes = () => (
  <BrowserRouter>
    <ScrollToTop>
      <RoutesContainer>
        <Route
          element={
            <SaveRouteParams keys={[{ name: 'id', storePath: LAST_REQUEST_ID }]}>
              <PrivateRoute>
                <VehicleDocumentsPage isVehicularCheckPoint />
              </PrivateRoute>
            </SaveRouteParams>
          }
          path={RoutesSettings.vehicularCheckPoint}
        />

        <Route
          element={
            <PrivateRoute>
              <VehicleDocumentsPage />
            </PrivateRoute>
          }
          path={RoutesSettings.vehicleDocuments}
        />

        <Route
          element={
            <SaveRouteParams keys={[{ name: 'ticket', storePath: AUTH_TOKEN }]}>
              <AuthRoute redirectTo={RoutesSettings.getRequestDetailUrl()} />
            </SaveRouteParams>
          }
          path={RoutesSettings.auth}
        />

        <Route
          element={
            <EmptyLayout>
              <SignInPage />
            </EmptyLayout>
          }
          path={RoutesSettings.signIn}
        />

        <Route
          element={
            <EmptyLayout>
              <SignUpPage />
            </EmptyLayout>
          }
          path={RoutesSettings.signUp}
        />

        <Route
          element={
            <PrivateRoute>
              <MainLayout title="Mis Vehículos">
                <VehiclesPage />
              </MainLayout>
            </PrivateRoute>
          }
          path={RoutesSettings.home}
        />

        <Route
          element={
            <PrivateRoute>
              <MainLayout isBackBehaviorEnable title="ADJUNTAR DOCUMENTOS">
                <AttachDocumentsPage />
              </MainLayout>
            </PrivateRoute>
          }
          path={RoutesSettings.attachDocuments}
        />
      </RoutesContainer>
    </ScrollToTop>
  </BrowserRouter>
);
